export default "__VITE_ASSET__CC54d5Rb__ 640w, __VITE_ASSET__Y5slw3hK__ 1024w, __VITE_ASSET__DSr$ASJp__ 1920w";